const bottomWindowItemInitial = {
    intialized: null,
    isActive: false,
    isShowed: false,
    data: undefined
}

const bottomWindowInitial = {
    expanded: false,
    maximized: false,
    height: 0,
    negInfo: { ...bottomWindowItemInitial },
    timeline: { ...bottomWindowItemInitial },
    subjects: { ...bottomWindowItemInitial }
}

const initialState = {
    bottomWindow: { ...bottomWindowInitial }
}

export { bottomWindowInitial, initialState as bottomWindowInitialState }
